const LS_KEY = 'spcx_hl'
const STYLE_ID = 'spcx-highlight-style'
const SKIP_TAGS = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA', 'INPUT', 'SELECT'])

export function storeHighlight(query: string) {
  try {
    localStorage.setItem(LS_KEY, query)
  } catch {}
}

export function applyHighlight() {
  let query: string | null = null
  try {
    query = localStorage.getItem(LS_KEY)
    if (query) localStorage.removeItem(LS_KEY)
  } catch {}
  if (!query) return

  const lower = query.toLowerCase()

  // Find first matching text node
  const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT)
  let node: Text | null = null
  let matchIndex = -1

  while (walker.nextNode()) {
    const n = walker.currentNode as Text
    const parent = n.parentElement
    if (!parent || SKIP_TAGS.has(parent.tagName)) continue
    const idx = n.nodeValue?.toLowerCase().indexOf(lower) ?? -1
    if (idx !== -1) {
      node = n
      matchIndex = idx
      break
    }
  }

  if (!node || matchIndex === -1) return

  // Inject highlight styles once
  if (!document.getElementById(STYLE_ID)) {
    const style = document.createElement('style')
    style.id = STYLE_ID
    style.textContent = `
      .spcx-highlight {
        background: #ffe066;
        border-radius: 2px;
        padding: 0 2px;
        transition: opacity 1s ease-out;
        opacity: 1;
      }
      .spcx-highlight--fade {
        opacity: 0;
      }
    `
    document.head.appendChild(style)
  }

  // Split text node to isolate the match
  const after = node.splitText(matchIndex)
  after.splitText(query.length)

  const mark = document.createElement('mark')
  mark.className = 'spcx-highlight'
  after.parentNode?.insertBefore(mark, after)
  mark.appendChild(after)

  mark.scrollIntoView({ behavior: 'smooth', block: 'center' })

  // Fade out then unwrap
  setTimeout(() => mark.classList.add('spcx-highlight--fade'), 2500)
  setTimeout(() => {
    const parent = mark.parentNode
    if (!parent) return
    while (mark.firstChild) parent.insertBefore(mark.firstChild, mark)
    parent.removeChild(mark)
    parent.normalize()
  }, 3500)
}
